import {StyleSheet} from 'react-native';

const style = StyleSheet.create({
  safeAreaView: {
    flex: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
  },
  children: {
    flex: 1,
  },
  staticContent: {
    flex: 1,
  },
});

export {style};
